import PropTypes from "prop-types"
import { get } from "lodash"
import { Table, TableHead, TableRow, TableCell } from "@mui/material"
import { numberFormatter } from "helpers/formatters/numbers"
import ContributorsOptions from "components/contributors-options"
import ContributorsSorting from "components/contributors-sorting"
import ContributorsTableContent from "components/contributors-table-content"
import ContributorsTableHead from "components/contributors-table-head"
import { sortData } from "helpers/contributorsSort"
import { VIEW_TYPES } from "helpers/base"
import { useTrack } from "helpers/analytics"
import "./style.scss"

function CompositeBetaContributors({
  viewType,
  selectedContributorValue,
  selectedContributorCategory,
  showContributorCategory,
  hideContributorCategory,
  data,
  openSecurityProfile,
  openCompositeSecurity,
  selectedGroup,
  selectedGroupSiblings,
  showGroup,
  hideGroup,
  setGrouping,
  currentGrouping,
  groupedData,
  openFactorProfile,
  sort,
  sortOrder,
  availableRollups,
  contributorsSummaryText,
  excelData,
  selectedOption,
  selectedGroupValue,
  showNotHeld,
  groupBy,
  details,
  groupOrder,
  groupsDropdownColumns,
  page,
  setPage,
}) {
  const trackExcelDownload = useTrack({
    type: "composite-analyze-beta-contributors-download",
  })

  const onBackClick = selectedGroup ? hideGroup : hideContributorCategory
  const selectedOptionColor = get(selectedOption, "color")

  return <div className="contributors-details-wrapper">
    <ContributorsOptions
      contributorsSummaryText={contributorsSummaryText}
      availableRollups={availableRollups}
      setGrouping={setGrouping}
      currentGrouping={currentGrouping}
      selectedGroup={selectedGroup}
      csvData={excelData}
      showNotHeld={showNotHeld}
      toggleShowNotHeld={null}
      groupBy={groupBy}
      trackExcelDownload={trackExcelDownload}
    />
    <Table className="contributors-details-table">
      <TableHead>
        <TableRow>
          <TableCell colSpan={3} align="right" title="% Contribution" className="contribution-dropdown-wrapper">
            <div>
              Net Contribution
            </div>
          </TableCell>
        </TableRow>
        <TableRow className="sorting-row">
          <ContributorsSorting label="Name" id="name" order={sortOrder} sort={sort} />
          <ContributorsSorting align="right" label={viewType === VIEW_TYPES.ABSOLUTE ? "% Equity" : "Active % Equity"} id="equity" order={sortOrder} sort={sort} />
          <ContributorsSorting align="right" label={viewType === VIEW_TYPES.ABSOLUTE ? "Absolute" : "Active"} id="viewType" order={sortOrder} sort={sort} />
        </TableRow>
        <TableRow>
          <ContributorsTableHead
            label={selectedGroup ? selectedGroup.name : selectedContributorCategory.label}
            color={selectedOptionColor}
            onBackClick={onBackClick}
            dropdownColumns={groupsDropdownColumns}
            dropdownItems={selectedGroup ? selectedGroupSiblings : sortData(details, groupOrder)}
            onDropdownItemClick={(item) => selectedGroup ? showGroup(item) : showContributorCategory(item)}
            selectedItemId={selectedGroup ? selectedGroup.id : selectedContributorCategory.id}
          />
          <TableCell align="right" style={{ color: selectedOptionColor }}>{selectedGroup ? numberFormatter(selectedGroup.totalPercentEquity * 100) : "-"}</TableCell>
          <TableCell align="right" style={{ color: selectedOptionColor }}>{numberFormatter(selectedGroup ? selectedGroupValue : selectedContributorValue) || "-"}</TableCell>
        </TableRow>
      </TableHead>
      <ContributorsTableContent
        selected={selectedContributorCategory}
        openSecurityProfile={openSecurityProfile}
        openFactorProfile={openFactorProfile}
        openCompositeSecurity={openCompositeSecurity}
        data={data}
        noPercent
        contributorsGrouping={currentGrouping}
        selectedGroup={selectedGroup}
        showGroup={showGroup}
        groupedData={groupedData}
        page={page}
        setPage={setPage}
      />
    </Table>
  </div>
}

CompositeBetaContributors.propTypes = {
  account: PropTypes.string.isRequired,
  modelId: PropTypes.string.isRequired,
  positionSetId: PropTypes.string.isRequired,
  positionSetType: PropTypes.string.isRequired,
  positionSetName: PropTypes.string.isRequired,
  classifications: PropTypes.array,
  factorCategoryName: PropTypes.string.isRequired,
  selectedContributorCategory: PropTypes.object.isRequired,
  selectedContributorValue: PropTypes.number.isRequired,
  showContributorCategory: PropTypes.func.isRequired,
  hideContributorCategory: PropTypes.func.isRequired,
  data: PropTypes.array.isRequired,
  viewType: PropTypes.string.isRequired,
  sortOrder: PropTypes.object.isRequired,
  sort: PropTypes.func.isRequired,
  openSecurityProfile: PropTypes.func.isRequired,
  openFactorProfile: PropTypes.func.isRequired,
  openCompositeSecurity: PropTypes.func.isRequired,
  selectedGroup: PropTypes.object,
  selectedGroupSiblings: PropTypes.array,
  showGroup: PropTypes.func.isRequired,
  hideGroup: PropTypes.func.isRequired,
  setGrouping: PropTypes.func.isRequired,
  currentGrouping: PropTypes.object,
  groupedData: PropTypes.array,
  missingDataFiles: PropTypes.object.isRequired,
  availableRollups: PropTypes.array.isRequired,
  contributorsSummaryText: PropTypes.string.isRequired,
  excelData: PropTypes.object.isRequired,
  selectedOption: PropTypes.object.isRequired,
  selectedGroupValue: PropTypes.number,
  showNotHeld: PropTypes.bool.isRequired,
  groupBy: PropTypes.string,
  details: PropTypes.array.isRequired,
  groupOrder: PropTypes.object.isRequired,
  groupsDropdownColumns: PropTypes.array,
  page: PropTypes.number.isRequired,
  setPage: PropTypes.func.isRequired,
}

export default CompositeBetaContributors
